import { css } from "@emotion/css";
import { Routes, Route } from "react-router-dom";
import Navbar from "../../shared/components/navbar/navbar";
import Footer from "../../shared/components/footer/footer";
import ProfileIndex from "./subpages/profile-index";
import ProfileOrders from "./subpages/profile-orders";
import ProfileOrderDetails from "./subpages/profile-order-details";
import ProfilePayment from "./subpages/profile-payment";
import ProfileWaitlist from "./subpages/profile-waitlist";
import ProfileTickets from "./subpages/profile-tickets";
import ProfileTicketsSchedule from "./subpages/profile-tickets-schedule";

const pageWrapper = css({
  minHeight: '100vh',
  background: 'var(--g-100)',
  display: 'flex',
  flexDirection: 'column',
});

const content = css({
  flex: 1,
  padding: 'var(--spacing-5xl) var(--spacing-sm)',
});

export function Profile() {
  return (
    <>
      <Navbar />
      <div className={pageWrapper}>
        <div className={content}>
          <Routes>
            <Route index element={<ProfileIndex />} />
            <Route path="compras" element={<ProfileOrders />} />
            <Route path="compras/:orderId" element={<ProfileOrderDetails />} />
            <Route path="ingressos" element={<ProfileTickets />} />
            <Route path="ingressos/:scheduleId" element={<ProfileTicketsSchedule />} />
            <Route path="pagamento" element={<ProfilePayment />} />
            <Route path="lista-espera" element={<ProfileWaitlist />} />
          </Routes>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Profile;
